module.exports = __webpack_public_path__ + "static/img/sign-bg.c051180.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-welfare/sign-bg.png
// module id = 4CCd
// module chunks = 216